import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

// Synchronously import local JSON files
import enTranslations from "../locales/en/common.json";
import arTranslations from "../locales/ar/common.json";
import { addDeleteGetLocalStorage, storageKeys } from "../utils/global/localData";

const TranslationContext = createContext();

const translationsMap = {
  en: enTranslations,
  ar: arTranslations,
};

const getInitialLang = () => {
  const storedLang = localStorage.getItem("lang");
  if (storedLang) return storedLang;

  try {
    const token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    if (token) {
      const decoded = jwtDecode(token);
      return decoded?.user?.preferredLang || "en";
    }
  } catch (error) {
    console.error("Error decoding token:", error);
  }

  return "en";
};

export const TranslationProvider = ({ children }) => {
  const initialLocale = getInitialLang();

  const [locale, setLocale] = useState(initialLocale);
  const [translations, setTranslations] = useState(translationsMap[initialLocale]);

  useEffect(() => {
    setTranslations(translationsMap[locale]);
    document.documentElement.dir = locale === "ar" ? "ltr" : "ltr";
  }, [locale]);

  const changeLocale = (newLocale) => {
    setLocale(newLocale);
    localStorage.setItem("lang", newLocale);
  };

  const t = (key) => {
    const keys = key?.split(".");
    return keys.reduce((acc, k) => acc?.[k], translations) || key;
  };

  return (
    <TranslationContext.Provider value={{ t, changeLocale, locale }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
